import { useCallback, useState } from "react";

/**
 * For boolean state that usually just needs to be toggled.
 *
 * @param initialValue
 */
export default function useToggleState(
  initialValue = false,
): [boolean, () => void] {
  const [value, setBoolValue] = useState<boolean>(initialValue);
  const toggle = useCallback(
    () => setBoolValue((previous) => !previous),
    [setBoolValue],
  );

  return [value, toggle];
}
